/** Recursively find all pending File uploads in a configuration object. */
export function findPendingUploadsDeep(obj, path = []) {
  if (!obj || typeof obj !== "object") return [];

  let results = [];
  if (obj.pendingFile instanceof File) {
    results.push({
      file: obj.pendingFile,
      path: path,
    });
  }

  for (const key of Object.keys(obj)) {
    if (obj[key] && typeof obj[key] === "object" && !(obj[key] instanceof File)) {
      results = results.concat(findPendingUploadsDeep(obj[key], [...path, key]));
    }
  }

  return results;
}

/** Apply a media upload result to a specific path in a configuration object. */
export function applyMediaUploadResultToNodeConfig(config, path, url, filename) {
  let nextConfig = { ...config };
  let current = nextConfig;

  for (let i = 0; i < path.length; i++) {
    const key = path[i];
    current[key] = { ...current[key] };
    current = current[key];
  }

  const isRoot = path.length === 0;
  const fieldName = isRoot ? "headerImageLink" : "url";

  current[fieldName] = url;
  current.filename = filename;
  delete current.pendingFile;

  // Clear any media IDs
  delete current.mediaId;
  delete current.headerImageMediaId;

  return nextConfig;
}
